module.exports = "<div class=\"text-center\">\n\n</div>\n"